var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Color, FontFamily } from '@atomic/obj.constants';
import { corPrimaria } from '../tema';
export var PillBadgeStyled = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.85rem;\n  font-weight: 700;\n  white-space: nowrap;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 7px 12px;\n  border-radius: 999px;\n  background: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: 0.85rem;\n  font-weight: 700;\n  white-space: nowrap;\n"])), function (_a) {
    var theme = _a.theme;
    return corPrimaria(theme);
}, Color.White, FontFamily.Secondary);
var templateObject_1;
